// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__16GPT","loaderOuter":"PageOverlayLoader_loaderOuter__3Oud1"};